'use strict';
import $ from 'jquery';

export default class M158 {
  static init() {
    $('.module-m158').each((index, el) => {
      new M158($(el));
    });
  }

  constructor($el) {
    this.el = $el;
    this.el.find('a').on('click', (e) => {
      e.preventDefault();
      this.el.find('.module-m158-image').hide();
      this.el.find('.wistia-video-frame').show();
    });
    window._wq = window._wq || [];
    // Once the play button on top of the image is pressed, the following onReady function will call,
    // so go ahead and start playback of the video.
    _wq.push({
      id: this.el.data('wistia-video-id'), onReady: function (video) {
        // Need a slight delay for some reason, otherwise the video won't actually start playing
        setTimeout(() => {
          video.play();
        }, 500);
      }
    });
  }
}
